import dynamic from 'next/dynamic'
import BasicLoader from '~/components/traffic-tickets/screens/basicLoader'
import Router from "next/router"
import {getRoot} from "mobx-state-tree"
import * as TrafficTicketService from '~/services/trafficTicket'
import {TRAFFIC_STATUS} from "~/utilities/constants"

const BASIC_DETAILS_CONFIGURATION = {
  slug: 'basic-details',
  Component: dynamic(() => import('./index'), {
    loading: BasicLoader
    // ssr: false
  }),
  validateKeys: ['ticketID'],
  validatationTarget: self => self.trafficTickets,
  // eslint-disable-next-line
  onEnter: async self => {
    self.setIsLoading(false)
  },
  onExit: async self => {
    try {
      const rootStore = getRoot(self)
      // prepare a list of ticketids to check
      const ticketIDs = self.trafficTickets.map(item => ({
        objectId: item.objectId,
        ticketID: item.ticketID
      }))
      // Get an array of is valid to create results
      const allowCreate = await TrafficTicketService.shouldAllowCreate(
        ticketIDs
      )

      const valid = {}
      allowCreate.forEach(item => {
        valid[item.ticketID] = item.allowCreate
      })

      // attach the errors to the ticket to show the user
      self.trafficTickets.forEach(trafficTicket => {
        if (!valid[trafficTicket.ticketID]) {
          trafficTicket.setDisplayErrors([
            {
              message: 'This ticket has already been submitted to WinIt',
              target: 'ticketID',
              fakeId: trafficTicket.fakeId
            }
          ])
        }
      })

      // If a single ticket is not valid do not allow the user to continue
      const allowContinue = Object.keys(valid).reduce((curr, ticketID) => {
        if (!curr) return curr
        return valid[ticketID]
      }, true)
      if (!allowContinue) {
        return false
      }

      // If ticket is already persisted update the keys
      const TRAFFIC_TICKET_KEYS_TO_SAVE = [
        'ticketID',
        'comment',
        'locationState',
        'status',
        'trafficRegion'
      ]
      // Upload ticket image
      self.trafficTickets.forEach((trafficTicket) => {
        trafficTicket.uploadTicketImage()
        if (!rootStore.trafficSubmission.selectedState.available && rootStore.trafficSubmission.selectedState.isPQFlowEnabled) {
          trafficTicket.setStatus(TRAFFIC_STATUS.pendingQuote)
        }
      })
      const updatedTickets = await self.updateTickets(
        TRAFFIC_TICKET_KEYS_TO_SAVE
      )
      if (!updatedTickets) {
        return false
      }
      if (!rootStore.trafficSubmission.selectedState.available && rootStore.trafficSubmission.selectedState.isPQFlowEnabled) {
        await Router.push("/pending-quote-thank-you")
        return false
      }
    } catch (err) {
      if (process.env.WINIT_ENV !== 'test') {
        console.error('error basic info on exit --', err)
      }
      return false
    }
    return true // true to contine
  }
}

export default BASIC_DETAILS_CONFIGURATION
